import { z } from 'zod';

export const DocumentTypeCodeZod = z.union([
    z.literal('AHCD'),
    z.literal('Cert_Trust'),
    z.literal('Cert_Trust_Joint'),
    z.literal('Cert_Trust_Spouse'),
    z.literal('Diagram'),
    z.literal('Diagram_Spouse'),
    z.literal('GDPOA'),
    z.literal('HCPOA'),
    z.literal('HIPAA'),
    z.literal('LW'),
    z.literal('MAD_Instr'),
    z.literal('MAD_Instr_Spouse'),
    z.literal('SI_Spouse_Will'),
    z.literal('SI_Trust'),
    z.literal('SI_Trust_Joint'),
    z.literal('SI_Trust_Spouse'),
    z.literal('SI_Will'),
    z.literal('Trust'),
    z.literal('Trust_Fund'),
    z.literal('Trust_Joint'),
    z.literal('Trust_Spouse'),
    z.literal('Will'),
    z.literal('Will_for_Spouse'),
    z.literal('Irrevocable_Gift_Trust'),
    z.literal('Irrevocable_Gift_Trust_SI'),
    z.literal('Irrevocable_Gift_Trust_Admin'),
    z.literal('Gift_Trust_Letter'),
    z.literal('Diagram_Irrevocable_Gift_Trust'),
    z.literal('Gift_Trust_Trustee_Acceptance'),
]);
export type DocumentTypeCode = z.infer<typeof DocumentTypeCodeZod>;
